/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutboundPlanScanOrder } from './OutboundPlanScanOrder';
import {
    OutboundPlanScanOrderFromJSON,
    OutboundPlanScanOrderFromJSONTyped,
    OutboundPlanScanOrderToJSON,
    OutboundPlanScanOrderToJSONTyped,
} from './OutboundPlanScanOrder';

/**
 * 
 * @export
 * @interface OutboundPlanForScanVo
 */
export interface OutboundPlanForScanVo {
    /**
     * 未扫描的唛头号数量
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    notScanMarkNoCount?: number;
    /**
     * 已扫描LCL唛头号数量
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    lclScanMarkNoCount?: number;
    /**
     * 已扫描Rocket唛头号数量
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    rocketScanMarkNoCount?: number;
    /**
     * 总订单数量
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    totalOrderCount?: number;
    /**
     * 总唛头号数量
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    totalMarkNoCount?: number;
    /**
     * 总箱数
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    totalBoxCount?: number;
    /**
     * 总托盘数
     * @type {number}
     * @memberof OutboundPlanForScanVo
     */
    totalPalletCount?: number;
    /**
     * 未扫描的唛头号列表
     * @type {Array<OutboundPlanScanOrder>}
     * @memberof OutboundPlanForScanVo
     */
    notScanOrderList?: Array<OutboundPlanScanOrder>;
    /**
     * 已扫描LCL唛头号列表
     * @type {Array<OutboundPlanScanOrder>}
     * @memberof OutboundPlanForScanVo
     */
    scanLCLOrderList?: Array<OutboundPlanScanOrder>;
    /**
     * 已扫描Rocket唛头号列表
     * @type {Array<OutboundPlanScanOrder>}
     * @memberof OutboundPlanForScanVo
     */
    scanRocketOrderList?: Array<OutboundPlanScanOrder>;
}

/**
 * Check if a given object implements the OutboundPlanForScanVo interface.
 */
export function instanceOfOutboundPlanForScanVo(value: object): value is OutboundPlanForScanVo {
    return true;
}

export function OutboundPlanForScanVoFromJSON(json: any): OutboundPlanForScanVo {
    return OutboundPlanForScanVoFromJSONTyped(json, false);
}

export function OutboundPlanForScanVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundPlanForScanVo {
    if (json == null) {
        return json;
    }
    return {
        
        'notScanMarkNoCount': json['notScanMarkNoCount'] == null ? undefined : json['notScanMarkNoCount'],
        'lclScanMarkNoCount': json['lclScanMarkNoCount'] == null ? undefined : json['lclScanMarkNoCount'],
        'rocketScanMarkNoCount': json['rocketScanMarkNoCount'] == null ? undefined : json['rocketScanMarkNoCount'],
        'totalOrderCount': json['totalOrderCount'] == null ? undefined : json['totalOrderCount'],
        'totalMarkNoCount': json['totalMarkNoCount'] == null ? undefined : json['totalMarkNoCount'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalPalletCount': json['totalPalletCount'] == null ? undefined : json['totalPalletCount'],
        'notScanOrderList': json['notScanOrderList'] == null ? undefined : ((json['notScanOrderList'] as Array<any>).map(OutboundPlanScanOrderFromJSON)),
        'scanLCLOrderList': json['scanLCLOrderList'] == null ? undefined : ((json['scanLCLOrderList'] as Array<any>).map(OutboundPlanScanOrderFromJSON)),
        'scanRocketOrderList': json['scanRocketOrderList'] == null ? undefined : ((json['scanRocketOrderList'] as Array<any>).map(OutboundPlanScanOrderFromJSON)),
    };
}

export function OutboundPlanForScanVoToJSON(json: any): OutboundPlanForScanVo {
    return OutboundPlanForScanVoToJSONTyped(json, false);
}

export function OutboundPlanForScanVoToJSONTyped(value?: OutboundPlanForScanVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notScanMarkNoCount': value['notScanMarkNoCount'],
        'lclScanMarkNoCount': value['lclScanMarkNoCount'],
        'rocketScanMarkNoCount': value['rocketScanMarkNoCount'],
        'totalOrderCount': value['totalOrderCount'],
        'totalMarkNoCount': value['totalMarkNoCount'],
        'totalBoxCount': value['totalBoxCount'],
        'totalPalletCount': value['totalPalletCount'],
        'notScanOrderList': value['notScanOrderList'] == null ? undefined : ((value['notScanOrderList'] as Array<any>).map(OutboundPlanScanOrderToJSON)),
        'scanLCLOrderList': value['scanLCLOrderList'] == null ? undefined : ((value['scanLCLOrderList'] as Array<any>).map(OutboundPlanScanOrderToJSON)),
        'scanRocketOrderList': value['scanRocketOrderList'] == null ? undefined : ((value['scanRocketOrderList'] as Array<any>).map(OutboundPlanScanOrderToJSON)),
    };
}

